import {
    getUsermanagementList, getList, update, insertList, set,queryOrgRoleList,setUserRole
} from '@/api/sys.usermanagement'

export default {
    namespaced: true,
    actions: {
        /**
         * 分页查询
         */
        getUsermanagementList({
                                  dispatch
                              }, {
                                  vm,
                                  page
                              }) {
            return getUsermanagementList(page)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        },
        getList({
                    dispatch
                }, {
                    vm,
                    pageable
                }) {
            return getList(pageable)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        },
        update({
                   dispatch
               }, {
                   vm,
                   form
               }) {
            return update(form)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        },
        insertList({
                       dispatch
                   }, {
                       vm,
                       table
                   }) {
            return insertList(table)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        },
        set({
                dispatch
            }, {
                vm,
                data
            }) {
            return set(data)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        },
        queryOrgRoleList({
                dispatch
            }, {
                vm,
                data
            }) {
            return queryOrgRoleList(data)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        },
        setUserRole({
                             dispatch
                         }, {
                             vm,
                             data
                         }) {
            return setUserRole(data)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        }
    }
}